<div class="box-layout box-layout-child"
     *ngIf="!isLoading && estimateConfig; else loadingTemplate">
  <h2>
    <pop-chevron [(isExpanded)]="showGeneral">
      <span class="h2"
            translate="OPTIONS.GENERAL"></span>
    </pop-chevron>
  </h2>

  <ng-container *ngIf="showGeneral">
    <pop-settings-box labelKey="OPTIONS.GROUP_BUDGETS">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.groupBudgetsByProjDept"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.GROUP_BUDGETS_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.LIMIT_INTERDEPARTMENT">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.limitInterdepartment"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.LIMIT_INTERDEPARTMENT_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.ACTIVATE_INTERNAL_FEES">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.activateInternalFees"
                  (isSwitchedChange)="activateInternalFeesChanged()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.ACTIVATE_INTERNAL_FEES_DESC"></div>
    </pop-settings-box>

    <pop-settings-box *ngIf="estimateConfig?.activateInternalFees"
                      labelKey="OPTIONS.LIMIT_INTERNAL_RESOURCE_BILLING_METHOD">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.limitInternalResourcesByBillingMethod"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.LIMIT_INTERNAL_RESOURCE_BILLING_METHOD_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.RESTRICT_ESTIMATE_LIST_ACCESS">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.restrictEstimateListAccess"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.RESTRICT_ESTIMATE_LIST_ACCESS_DESC"></div>
    </pop-settings-box>
  </ng-container>

  <h2 class="new-section">
    <pop-chevron [(isExpanded)]="showBilling">
      <span class="h2"
            translate="PROPERTY_MODAL.BILLING"></span>
    </pop-chevron>
  </h2>
  <ng-container *ngIf="showBilling">
    <pop-settings-box labelKey="OPTIONS.MAX_BUDGETED">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.useMaxBudgeted"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.MAX_BUDGETED_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.FIXED_MAX_BUDGETED">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.forceMaxBudgeted"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.FIXED_MAX_BUDGETED_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.USE_LABOR_BILLING_METHOD">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.useLaborBillingMethod"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.LABOR_BILLING_METHOD_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.FORCE_LABOR_BILLING_METHOD">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.forceLaborBillingMethod"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.FORCE_LABOR_BILLING_METHOD_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.USE_LABOR_BILLING_METHOD_LUMP_SUM">
      <pop-switch middle
                  [(isSwitched)]="estimateConfig.useLaborBillingMethodWhenLumpSum"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.USE_LABOR_BILLING_METHOD_LUMP_SUM_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.SERVICE_OFFER_TYPE_ID">
      <pop-service-type-picker styleClass="rem-fix"
                               [(selectedServiceType)]="selectedServiceType"
                               (selectedServiceTypeChange)="onSelectedServiceTypeChange()">
      </pop-service-type-picker>
      <div aside
           class="description"
           translate="OPTIONS.SERVICE_OFFER_TYPE_ID_DESC"></div>
    </pop-settings-box>
  </ng-container>

  <h2 class="new-section">
    <pop-chevron [(isExpanded)]="showCurrency">
      <span class="h2"
            translate="OPTIONS.CURRENCY"></span>
    </pop-chevron>
  </h2>
  <ng-container *ngIf="showCurrency">
    <pop-settings-box labelKey="OPTIONS.COMPANY">
      <select middle
              id="companySelect"
              class="settings-field"
              [(ngModel)]="selectedCompanyKey"
              *ngIf="companies; else loadingTemplate"
              (change)="fillCurrencies(selectedCompanyKey)">
        <option *ngFor="let company of companies"
                [label]="company"
                [value]="company"></option>
      </select>

      <div aside
           class="description"
           translate="OPTIONS.COMPANY_CURRENCY"></div>
    </pop-settings-box>

    <div *ngFor="let currency of selectedCompanyCurrencies"
         [class.is-functional]="currency.isFunctional">
      <pop-currency-line [companyCurrencies]="selectedCompanyCurrencies"
                         [currency]="currency"
                         (currencyChange)="changed()"></pop-currency-line>
    </div>
  </ng-container>

  <h2 class="new-section">
    <pop-chevron [(isExpanded)]="showClasses">
      <span class="h2"
            translate="OPTIONS.CLASSES"></span>
    </pop-chevron>
  </h2>
  <ng-container *ngIf="showClasses">
    <div class="class-section">
      <div class="setting-box-wrapper">
        <pop-settings-box labelKey="OPTIONS.INCLUDED_CLASS"
                          [vertical]="true">
          <div class="settings-class-box"
               contenteditable="true"
               (keydown.control.a)="selectAllClassIncluded($event)">
            <div class="settings-class-list"
                 *ngFor="let class of activeClassifications"
                 (click)="selectClass(class.code)"
                 [class.selected-classification]="selectedClassifications.includes(class.code)">
              <div>
                <span class="class-code-span">
                  {{ class.code }}
                </span>
                <span>
                  {{ class | classDescription: currentLang }}
                </span>
              </div>
            </div>
          </div>
        </pop-settings-box>

        <pop-settings-box labelKey="OPTIONS.EXCLUDED_CLASS"
                          [vertical]="true">
          <div class="settings-class-box"
               contenteditable="true"
               (keydown.control.a)="selectAllClassExcluded($event)">
            <div class="settings-class-list"
                 *ngFor="let class of inactiveClassifications"
                 (click)="selectClass(class.code)"
                 [class.selected-classification]="selectedClassifications.includes(class.code)">
              <div>
                <span class="class-code-span">
                  {{ class.code }}
                </span>
                <span>
                  {{ class | classDescription: currentLang }}
                </span>
              </div>
            </div>
          </div>
        </pop-settings-box>
      </div>

      <div class="class-switch-btn"
           (click)="switchClassifications()">
        <i class="fas fa-level-down-alt"></i>
        <i class="fas fa-level-up-alt"></i>
      </div>

      <div class="description"
           translate="OPTIONS.CLASSES_DESC">
      </div>
    </div>
  </ng-container>

  <h2 class="new-section">
    <pop-chevron [(isExpanded)]="showResources">
      <span class="h2"
            translate="OPTIONS.RESOURCES"></span>
    </pop-chevron>
  </h2>
  <ng-container *ngIf="showResources">
    <div class="resource-section">
      <div *ngIf="!isLoading; else loadingTemplate"
           class="setting-box-wrapper">
        <pop-settings-box labelKey="OPTIONS.INCLUDED_RESOURCE"
                          [vertical]="true">
          <div class="settings-class-box"
               contenteditable="true"
               (keydown.control.a)="selectAllResoucesIncluded($event)">
            <div class="settings-class-list"
                 *ngFor="let class of includedClassifications"
                 (click)="selectResource(class.code)"
                 [class.selected-classification]="selectedClassificationResources.includes(class.code)">
              <div>
                <span class="class-code-span">
                  {{ class.code }}
                </span>
                <span>
                  {{ class | classDescription: currentLang }}
                </span>
              </div>
            </div>
          </div>
        </pop-settings-box>
        <pop-settings-box labelKey="OPTIONS.EXCLUDED_RESOURCE"
                          [vertical]="true">
          <div class="settings-class-box"
               contenteditable="true"
               (keydown.control.a)="selectAllResourceExcluded($event)">
            <div class="settings-class-list"
                 *ngFor="let class of excludedClassifications"
                 (click)="selectResource(class.code)"
                 [class.selected-classification]="selectedClassificationResources.includes(class.code)">
              <div>
                <span class="class-code-span">
                  {{ class.code }}
                </span>
                <span>
                  {{ class | classDescription: currentLang }}
                </span>
              </div>
            </div>
          </div>
        </pop-settings-box>
      </div>

      <div class="class-switch-btn"
           (click)="switchResources()">
        <i class="fas fa-level-down-alt"></i>
        <i class="fas fa-level-up-alt"></i>
      </div>

      <div class="description"
           translate="OPTIONS.RESOURCES_DESC">
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <pop-loading [isInline]="true"></pop-loading>
</ng-template>
